import React from "react";
import CustomTooltip from "../CustomTooltip";

const ConfigButton = ({ action, disable, icon, label, fontLabelSize, helpKey, helpLabel, status }) => {

    const statusColor = {
        "Feito": "#28a745",
        "Criando...": "#e8c743",
        "Erro": "#ff0000",
        "Erro status": "#e05a00ff",
        "Em andamento...": "#e8c743",
        "Concluído": "#28a745",
    }

    const styles = {
        cursor: disable ? 'not-allowed' : 'pointer',
        border: '1px solid #ccc',
        borderRadius: '5px',
        padding: '5px',
        width: '160px',
        height: '180px',
        margin: '5px',
        position: 'relative',
        background: 'transparent',
        
    }
    const flagStatusStyle = {
        position: 'absolute',
        top: '6px',
        left: '7px',
        borderRadius: '20px',
        backgroundColor: 'green',
        color: "ativado" ? "#000" : "#fff",
        fontSize: '12px', 
        textAlign: 'center',
        padding: '2px 5px',
        backgroundColor: statusColor[status],
    }
    return (
        <button disabled={disable} onClick={action} 
             className="d-flex align-items-center justify-content-center flex-column" 
             style={styles}>
             <CustomTooltip key={helpKey}
                            label={helpLabel}  
                            customStyle={{position: 'absolute', top: '3px', right: '5px'}}  
                            customStylePopup={{width: '200px', backgroundColor: '#000', color: '#fff', top: '30px', left: '-185px'}}
             />
             {icon} 
             <span className="mt-2" style={{fontSize: fontLabelSize, textAlign: 'center' }}>{label}</span>
             {status && <div style={flagStatusStyle}>{status}</div>}
        </button>
    );
};

export default ConfigButton;